import { Box, Flex } from '@chakra-ui/react';
import SkeletonComponent from 'UiKit/skeleton';

const SkeletonSidebar = () => {
  return (
    <Box>
      <Flex height="58px" alignItems="center" mb="24px" justifyContent="space-between" padding={'0 16px'}>
        <SkeletonComponent height="34px" width="94px" />
        <SkeletonComponent height="24px" width="24px" />
      </Flex>

      <Flex gap="8px" height="32px" alignItems="center" mb="12px" pl="16px">
        <SkeletonComponent height="18px" width="18px" />
        <SkeletonComponent height="18px" width="120px" />
      </Flex>

      <Box mb="12px" p="0 16px">
        <Flex alignItems="center" justifyContent="space-between">
          <Flex gap="8px" height="32px" alignItems="center">
            <SkeletonComponent height="18px" width="18px" />
            <SkeletonComponent height="18px" width="120px" />
          </Flex>

          <SkeletonComponent height="18px" width="18px" />
        </Flex>
        <Flex height={'32px'} alignItems="center" pl="30px">
          <SkeletonComponent height="18px" width="120px" pl="30px" />
        </Flex>
        <Flex height={'32px'} alignItems="center" pl="30px">
          <SkeletonComponent height="18px" width="120px" pl="30px" />
        </Flex>
        <Flex height={'32px'} alignItems="center" pl="30px">
          <SkeletonComponent height="18px" width="120px" pl="30px" />
        </Flex>
      </Box>

      <Box mb="12px" p="0 16px">
        <Flex alignItems="center" justifyContent="space-between">
          <Flex gap="8px" height="32px" alignItems="center">
            <SkeletonComponent height="18px" width="18px" />
            <SkeletonComponent height="18px" width="120px" />
          </Flex>

          <SkeletonComponent height="18px" width="18px" />
        </Flex>
        <Flex height={'32px'} alignItems="center" pl="30px">
          <SkeletonComponent height="18px" width="120px" pl="30px" />
        </Flex>
        <Flex height={'32px'} alignItems="center" pl="30px">
          <SkeletonComponent height="18px" width="120px" pl="30px" />
        </Flex>
        <Flex height={'32px'} alignItems="center" pl="30px">
          <SkeletonComponent height="18px" width="120px" pl="30px" />
        </Flex>
      </Box>

      <Box mb="12px" p="0 16px">
        <Flex alignItems="center" justifyContent="space-between">
          <Flex gap="8px" height="32px" alignItems="center">
            <SkeletonComponent height="18px" width="18px" />
            <SkeletonComponent height="18px" width="120px" />
          </Flex>

          <SkeletonComponent height="18px" width="18px" />
        </Flex>
        <Flex height={'32px'} alignItems="center" pl="30px">
          <SkeletonComponent height="18px" width="120px" pl="30px" />
        </Flex>
        <Flex height={'32px'} alignItems="center" pl="30px">
          <SkeletonComponent height="18px" width="120px" pl="30px" />
        </Flex>
        <Flex height={'32px'} alignItems="center" pl="30px">
          <SkeletonComponent height="18px" width="120px" pl="30px" />
        </Flex>
      </Box>
    </Box>
  );
};

export default SkeletonSidebar;
